export default {"src":"/_next/static/media/beta-desktop-inverted.41a5c0bf.svg","height":100,"width":415,"blurWidth":0,"blurHeight":0};